// Exposes a get method on a given object that takes a dot-delimitted string
// and a default value
const getNestedAttrs = obj => {
  return {
    ...obj,
    get(strPath, defaultVal) {
      let val = this;
      strPath.split('.').forEach(selector => {
        if (typeof val === 'undefined') {
          return defaultVal;
        }

        val = val[selector];
      });
      return val;
    }
  };
};

export default getNestedAttrs;



// WEBPACK FOOTER //
// ./app/javascript/app/utils/getNestedAttrs.js